<form [formGroup]="form">
  <div class="grid">
    @for (filter of filters.controls; track $index; let i = $index) {
      <div class="col-12">
        <div class="grid formgrid">
          @if (i === 0 && filters.controls.length > 1) {
            <div class="col-2 field"></div>
          }
          @if (i === 1) {
            <div class="col-2 field">
              <p-floatlabel variant="on">
                <p-select id="unionType"
                          [options]="unionTypes"
                          formControlName="unionType"
                          appendTo="body"
                          class="w-full">
                </p-select>
                <label for="unionType"
                       i18n>Union</label>
              </p-floatlabel>
            </div>
          }
          @if (i > 1) {
            <div class="col-2 field">
              <input pInputText
                     i18n
                     disabled="true"
                     value="{{unionTypeLabel}}"
                     class="w-full" />
            </div>
          }
          <ng-container formArrayName="filters">
            <ng-container [formGroupName]="i">
              <div class="col-4 field">
                <p-floatlabel variant="on">
                  <p-select scValidatable
                            scLabelText="Field Type"
                            id="definition"
                            [options]="filterDefinitions"
                            [virtualScroll]="true"
                            formControlName="definition"
                            optionLabel="label"
                            appendTo="body"
                            class="w-full">
                  </p-select>
                  <label for="definition"
                         class="sc-required-input"
                         i18n>Field Type</label>
                </p-floatlabel>
              </div>
              <div class="col-2 field">
                <p-floatlabel variant="on">
                  <p-select scValidatable
                            scLabelText="Filter"
                            id="operator"
                            [options]="getDefinition(filter)?.operators"
                            formControlName="operator"
                            optionLabel="name"
                            appendTo="body"
                            class="w-full">
                  </p-select>
                  <label for="operator"
                         class="sc-required-input"
                         i18n>Filter</label>
                </p-floatlabel>
              </div>
              <div class="col-3 field">
                @switch (getOperator(filter)?.renderAs) {
                  @case (renderAs.string) {
                    <p-floatlabel variant="on">
                      <input scValidatable
                             id="value"
                             formControlName="value"
                             pInputText
                             type="text"
                             class="w-full" />
                      <label for="value"
                             i18n
                             class="sc-required-input">Value</label>
                    </p-floatlabel>
                  }
                  @case (renderAs.number) {
                    <p-floatlabel variant="on">
                      <p-inputNumber scValidatable
                                     id="value"
                                     formControlName="value"
                                     class="w-full"></p-inputNumber>
                      <label for="value"
                             i18n
                             class="sc-required-input">Value</label>
                    </p-floatlabel>
                  }
                  @case (renderAs.select) {
                    <p-floatlabel variant="on">
                      <p-select #dropdownRef
                                scValidatable
                                scLabelText="Value"
                                id="value"
                                [options]="getOperator(filter)?.values | async"
                                [filter]="dropdownRef.options?.length > 5"
                                formControlName="value"
                                appendTo="body"
                                class="w-full">
                      </p-select>
                      <label for="value"
                             class="sc-required-input"
                             i18n>Value</label>
                    </p-floatlabel>
                  }
                  @case (renderAs.multiselect) {
                    <p-floatlabel variant="on">
                      <p-multiSelect #multiselectRef
                                     scValidatable
                                     scLabelText="Value"
                                     id="value"
                                     [filter]="multiselectRef.options?.length > 5"
                                     [showToggleAll]="false"
                                     [showHeader]="false"
                                     [options]="getOperator(filter)?.values | async"
                                     formControlName="value"
                                     appendTo="body"
                                     class="w-full">
                      </p-multiSelect>
                      <label for="value"
                             class="sc-required-input"
                             i18n>Value</label>
                    </p-floatlabel>
                  }
                  @case (renderAs.dateRange) {
                    <p-datePicker scValidatable
                                  dateFormat="dd/mm/yy"
                                  [readonlyInput]="true"
                                  placeholder="Value"
                                  i18n-placeholder
                                  formControlName="value"
                                  selectionMode="range"
                                  inputStyleClass="w-full"
                                  class="w-full">
                    </p-datePicker>
                  }
                }
              </div>
              <div class="col-1">
                @if (i > 0) {
                  <p-button (onClick)="deleteFilter(i)"
                            icon="pi pi-times"
                            styleClass="p-button-rounded">
                  </p-button>
                }
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    }
  </div>
</form>

<div class="grid grid-nogutter">
  <div class="col-12">
    <div class="grid grid-nogutter mb-4">
      <div class="col-2">
        <p-button (onClick)="addFilter()"
                  icon="pi pi-plus"
                  label="Add Filter"
                  i18n-label
                  styleClass="p-button-outlined p-button-secondary">
        </p-button>
      </div>
      <div class="col-2">
        <p-button (onClick)="clearFilters()"
                  label="Discard"
                  i18n-label
                  styleClass="p-button-text">
        </p-button>
      </div>
    </div>
  </div>
  <div class="col-12 sc-dialog-buttons">
    <p-button (onClick)="applyFilter()"
              i18n-label
              label="Apply Filter">
    </p-button>
    <p-button (onClick)="saveAsTemplate()"
              [disabled]="!saveAsTemplateEnabled"
              i18n-label
              label="Save as Template"
              icon="fas fa-bookmark"
              styleClass="p-button-text">
    </p-button>
  </div>
</div>